// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateSearch_search__0V0W3 .CertificateSearch_title__Tv7jP {
  margin: 0 3px 37px 0;
  font-family: Roboto;
  font-size: 38px;
  font-weight: 300;
  line-height: 1.45;
  letter-spacing: 0.5px;
  text-align: center;
}
.CertificateSearch_search__0V0W3 .CertificateSearch_searchBtn__kBB1d {
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.CertificateSearch_results__EcBG6 {
  margin-bottom: 72px;
}
.CertificateSearch_results__EcBG6 .CertificateSearch_result__-df5r {
  display: flex;
  flex-direction: row;
  padding: 24px;
  gap: 16px;
  font-weight: 300;
}
.CertificateSearch_results__EcBG6 .CertificateSearch_result__-df5r .CertificateSearch_certificateNumber__AivaW {
  width: 240px;
}
.CertificateSearch_results__EcBG6 .CertificateSearch_result__-df5r .CertificateSearch_title__Tv7jP {
  flex: 1 1;
}
.CertificateSearch_results__EcBG6 .CertificateSearch_result__-df5r .CertificateSearch_action__Ad1S9 {
  display: flex;
  align-items: center;
}
.CertificateSearch_results__EcBG6 .CertificateSearch_result__-df5r .CertificateSearch_header__VvyyU {
  color: grey;
  margin-bottom: 8px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/CertificateSearch/CertificateSearch.module.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,wCAAA;EACA,8CAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAEI;EACE,YAAA;AAAN;AAEI;EACE,SAAA;AAAN;AAEI;EACE,aAAA;EACA,mBAAA;AAAN;AAEI;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAAN","sourcesContent":[".search {\r\n  .title {\r\n    margin: 0 3px 37px 0;\r\n    font-family: Roboto;\r\n    font-size: 38px;\r\n    font-weight: 300;\r\n    line-height: 1.45;\r\n    letter-spacing: 0.5px;\r\n    text-align: center;\r\n  }\r\n\r\n  .searchBtn {\r\n    background-color: var(--bs-btn-hover-bg);\r\n    border-color: var(--bs-btn-hover-border-color);\r\n  }\r\n}\r\n\r\n.results {\r\n  margin-bottom: 72px;\r\n  .result {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding: 24px;\r\n    gap: 16px;\r\n    font-weight: 300;\r\n    .certificateNumber {\r\n      width: 240px;\r\n    }\r\n    .title {\r\n      flex: 1;\r\n    }\r\n    .action {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n    .header {\r\n      color: grey;\r\n      margin-bottom: 8px;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `CertificateSearch_search__0V0W3`,
	"title": `CertificateSearch_title__Tv7jP`,
	"searchBtn": `CertificateSearch_searchBtn__kBB1d`,
	"results": `CertificateSearch_results__EcBG6`,
	"result": `CertificateSearch_result__-df5r`,
	"certificateNumber": `CertificateSearch_certificateNumber__AivaW`,
	"action": `CertificateSearch_action__Ad1S9`,
	"header": `CertificateSearch_header__VvyyU`
};
export default ___CSS_LOADER_EXPORT___;
